module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_office-98553a9663abd99cd224be5bfb5b30b2.svg";